module.exports = __webpack_public_path__ + "img/mm-howto-en.118b55ad.png";